<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <label class="label" for="vehiculo">Facturación</label>
      <div class="card">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <template>
                <div class="col-12 form-group form-group-sm">
                  <label class="label" for="empresaPropia"
                    >Empresa Propia Facturadora</label
                  >
                  <SelectorEmpresaPropia
                    v-model="empresaPropia"
                    @ready="empresaPropiaReady"
                    :clienteId="clienteId"
                    id="empresaPopia"
                  />
                </div>
              </template>

              <template v-if="mostrarEmpresasDelCliente">
                <div
                  v-if="inicializado"
                  class="col-12 col-md-7 form-group form-group-sm"
                >
                  <label class="label" for="empresa">Empresa del Cliente</label>

                  <multiselect-item
                    id="empresa"
                    v-model="empresa"
                    :options="empresaOptions"
                    placeholder="Seleccione un empresa"
                    track-by="id_empresa"
                    :selectLabel="''"
                    deselectLabel=""
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="option__desc">
                        <span class="option__title"
                          >{{ props.option.RazonSocial }}
                          {{
                            props.option.CUIT
                              ? ` - CUIT: ${props.option.CUIT}`
                              : ""
                          }}</span
                        ><br />
                        <span class="option__small">
                          {{ props.option.contratos_por_empresa }} contratos
                        </span>
                      </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{
                          props.option.RazonSocial
                        }}</span
                        ><br />
                        <span class="option__small">
                          {{ props.option.contratos_por_empresa }} contratos
                        </span>
                      </div>
                    </template>
                  </multiselect-item>
                </div>
                <div class="col-12" v-show="!inicializado">Cargando ...</div>
                <div
                  v-if="inicializado && empresa && empresa.id_empresa !== 0"
                  class="col-12 col-md-5 form-group form-group-sm"
                >
                  <label class="label" for="subfactura">Subfactura</label>

                  <multiselect-item
                    id="subfactura"
                    v-model="subfactura"
                    :options="empresa.subfacturas"
                    placeholder="Elija subfactura"
                    track-by="subfactura"
                    :selectLabel="''"
                    deselectLabel=""
                    :custom-label="
                      (subf) =>
                        `${subf.subfactura} -  ${subf.contratos} contratos `
                    "
                  >
                  </multiselect-item>
                </div>
              </template>
              <template
                v-if="
                  inicializado &&
                  empresaOptions.length === 0 &&
                  empresaPropia &&
                  empresaPropia.id !== 0
                "
              >
                <div class="col-12 form-group">
                  <small>El cliente no tiene empresas</small>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
import SelectorEmpresaPropia from "../../../Clientes/shared/SelectorEmpresaPropia.vue";
import axios from "axios";

export default {
  name: "EmpresasFacturacionForm",
  components: { SelectorEmpresaPropia },

  data: () => ({
    empresaOptions: [],
    inicializado: false,
  }),
  methods: {
    async empresaPropiaReady() {
      this.inicializado = false;
      this.getEmpresas().then((data) => {
        if (!data.ok) {
          this.$msgBoxOk(data.message);
        }
      });
    },
    async getEmpresas() {
      this.inicializado = false;
      const { data } = await axios.post("/execute", {
        method: "CLI.GetEmpresasSimplesWithSubfacturasByClienteId",
        parameters: [
          {
            name: "id_cliente",
            value: this.$route.params.id_cliente,
          },
        ],
      });
      const empresas = get(data, "result[0]", []);

      const empresaOptions = empresas.reduce((carry, curr) => {
        if (carry.length === 0) {
          const empresa = { ...curr };
          empresa.subfacturas = [
            { subfactura: curr.subfactura, contratos: curr.contratos },
          ];
          return [empresa];
        }

        let empresaIndex = carry.findIndex(
          (e) => e.id_empresa === curr.id_empresa,
        );

        if (empresaIndex === -1) {
          const empresa = { ...curr };
          empresa.subfacturas = [
            { subfactura: curr.subfactura, contratos: curr.contratos },
          ];
          return [...carry, empresa];
        } else {
          carry[empresaIndex].subfacturas.push({
            subfactura: curr.subfactura,
            contratos: curr.contratos,
          });
          return carry;
        }
      }, []);

      this.empresaOptions = empresaOptions.map((e) => {
        const mayorSubfactura = e.subfacturas.sort(
          (subfA, subfB) => subfA.subfactura - subfB.subfactura,
        )[e.subfacturas.length - 1];
        e.subfacturas.push({
          subfactura: mayorSubfactura.subfactura + 1,
          contratos: 0,
        });
        return e;
      });

      if (this.empresa) {
        this.empresa = this.empresaOptions.find(
          (empresa) => empresa.id_empresa === this.empresa,
        );
        if (this.empresa && this.empresa.subfacturas)
          this.subfactura = this.empresa.subfacturas.find(
            (sub) => sub.subfactura === this.subfactura,
          );
      }

      this.inicializado = true;
      return data;
    },
  },
  computed: {
    clienteId() {
      return this.$route.params.id_cliente;
    },
    mostrarEmpresasDelCliente() {
      return get(this.empresaPropia, "id_empresas_propias", 0) !== 0;
    },
    empresa: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.empresa;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setEmpresa", val);
        if (this.inicializado) {
          this.$store.commit("Contratos/NuevoContrato/setSubfactura", null);
        }
      },
    },
    subfactura: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.subfactura;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setSubfactura", val);
      },
    },
    empresaPropia: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.empresaPropia;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setEmpresaPropia", val);
        if (this.inicializado) {
          this.$store.commit("Contratos/NuevoContrato/setEmpresa", null);

          this.$store.commit("Contratos/NuevoContrato/setSubfactura", null);
        }
      },
    },
  },
};
</script>

<style scoped></style>
